<template>
  <v-container fluid>
    <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
    <v-divider class="my-5"></v-divider>
    <span v-html="editorData"></span>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'TestCKEditorForm',
  components: {},
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      editorData: null,
      editorConfig: {
        language: 'lt',
        toolbarGroups: [
          { name: 'document', groups: ['mode', 'document', 'doctools'] },
          { name: 'clipboard', groups: ['clipboard', 'undo'] },
          {
            name: 'editing',
            groups: ['find', 'selection', 'spellchecker', 'editing'],
          },
          { name: 'forms', groups: ['forms'] },
          { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
          {
            name: 'paragraph',
            groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
          },
          { name: 'links', groups: ['links'] },
          '/',
          { name: 'insert', groups: ['insert'] },
          { name: 'styles', groups: ['styles'] },
          { name: 'colors', groups: ['colors'] },
          { name: 'tools', groups: ['tools'] },
          '/',
          { name: 'others', groups: ['others'] },
        ],
      },
    }
  },
  computed: {},
  beforeDestroy() {},
  created() {},
  methods: {},
}
</script>
<style lang="scss" scoped></style>
